import { Component, OnInit } from '@angular/core';
import { ModelRestService } from '../../model-rest.service';
import { SessionService } from '../../session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Schedule } from '../../model/schedule';
import { Segment } from '../../model/segment';
import { Response } from '../../model/response';
import { TrainStop } from '../../model/trainstop';
import { Travel } from '../../model/travel';
import { AvailabilityQuery } from '../../model/availabilityquery';
import { Direction } from '../../model/direction';
import { AvailabilityQuery2 } from '../../model/availabilityquery2';
import { Route2 } from '../../model/route2';
import { Observable } from 'rxjs/Rx';
import { TranslateService } from '@ngx-translate/core';
/**Componente del paso donde se muestra el modal de no disponibilidad*/
@Component({
  selector: 'app-step3',
  templateUrl: './step3.component.html',
  styleUrls: ['./step3.component.css']
})
export class Step3Component implements OnInit {

  constructor(private activated_route: ActivatedRoute,private location: Location,
    private translate: TranslateService,
    private model: ModelRestService,
    public session: SessionService,
    private router: Router,
    private aroute: ActivatedRoute) { }
  /** .*/
  public segments: Segment[] = [];
  /** .*/
  public schedule: Schedule = null;
  /** .*/
  public dateWeek;
  /** .*/
  public btnNext = true;
  /** .*/
  public displayModal = false;
  /** .*/
  public notifTitle = "";
  /** .*/
  public notifBody = "";
  /** .*/
  public notifBody1 = "";
  /** .*/
  public notifBody2 = "";
  /** .*/
  public notifBody3 = "";
  /** .*/
  public notifBody11 = "";
  /** .*/
  public isLoading = true;

  /**Se valida si existe disponibilidad y si no lo hay, arma el model de no disponibilidad y si hay disponibilidad te manda al siguiente paso  */
  ngOnInit() {
    console.clear();
    this.checkQueryString().subscribe((r: boolean) => {
      if (!this.session || !this.session.query || !this.session.route) {
        this.router.navigate(["/reservaciones/"]); return;
      }

      let query: AvailabilityQuery = this.session.query.toAvailabilityQuery(this.session.route);
       
      

      this.model.getRouteScheduleAvailable(this.session.route.id, query).subscribe((response: Response<Schedule>) => {
        
        if (response.success && response.data.travels.length > 0) {
          this.schedule = response.data;
          this.session.schedule = response.data;         
          this.segments = this.makeSegments(this.schedule, query);
          this.session.segments = this.segments;

          this.segments.forEach(e => {
            this.onTravelSelected(e, e.travels[0])
          });
     
          this.router.navigate(["/" + this.session.route.name + "/registro"]); return;

        } 
        else {
          // alert("No se lograron obtener opciones de viaje, elija otras opciones de búsqueda e inténtelo de nuevo");
          if (this.session.route.name == 'Express') {
            this.isLoading = false
            this.displayModal = true;
            this.notifTitle = "No hay disponibilidad";
            this.notifBody = "El tren no cuenta con disponibilidad para las fechas y clase que elegiste, te invitamos a buscar en otra fecha.";
            this.notifBody1 = "Para una mayor asistencia comunícate al 800 122 4373"
            this.notifBody11 = ""
            this.notifBody2 = ""
            this.notifBody3 = ""            
          }
          else {
            this.isLoading = false
            this.displayModal = true;
            this.notifTitle = "No hay disponibilidad";
            this.notifBody = "El tren no cuenta con disponibilidad para las fechas y clase que elegiste, te invitamos a buscar en otra fecha.";
            this.notifBody1 = "Para una mayor asistencia comunícate al 800 122 4373"
            this.notifBody11 = ""
            this.notifBody2 = ""
            this.notifBody3 = ""  
          }

        }

      });
    });

    this.segments = this.session.mkUnifiedSegments();
    this.session.segments = this.segments;
    if (!this.session || !this.session.query || !this.session.segments || !this.session.route) {
      this.router.navigate(["/reservaciones"]); return;
    }
  }

  private selectTrips() {

  }

  /** .*/
  fixQuery(query: AvailabilityQuery): AvailabilityQuery {
    return query;
  }
  /** .*/
  mkDate(s: string): Date {
    var mps: string[] = s.split(" ");
    let now: Date = new Date();
    if (mps.length == 1) {
      mps.push("00:00:01");
    }
    let dps: string[] = mps[0].split("-");
    let tps: string[] = mps[1].split(":");

    let year: number = dps.length >= 1 ? parseInt(dps[0]) : now.getFullYear();
    let month: number = dps.length >= 2 ? parseInt(dps[1]) - 1 : now.getMonth();
    let day: number = dps.length >= 3 ? parseInt(dps[2]) : now.getDate();

    let hour: number = tps.length >= 1 ? parseInt(tps[0]) : now.getHours();
    let minute: number = tps.length >= 2 ? parseInt(tps[1]) : now.getMinutes();
    let second: number = tps.length >= 3 ? parseInt(tps[2]) : now.getSeconds();

    let dd: Date = new Date(year, month, day + 1, hour, minute, second);
    return dd;
  }
  /** .*/
  public onTravelSelected(segment: Segment, travel: Travel) {
    segment.selected_travel = travel;

    for (var a = 0; a <= segment.n; a++) {
      var d = segment.selected_travel.getWeekday()

      var dateWee = [d];

      if (dateWee[0] == "Jueves") {
        this.dateWeek = this.translate.instant('Step3-P16');
      }
    }
  }
  /** .*/
  public lenguajeWeekDay() {

  }

  /** .*/
  checkQueryString() {

    let route_name = this.activated_route.snapshot.paramMap.get("route_name");
    return new Observable<boolean>((observer) => {
      this.aroute.queryParams.subscribe((params) => {
        
        if (params.start && params.end && params.src && params.dst && params.round) {
          this.model.getRoute(route_name).subscribe((r: Response<Route2>) => {
            
            this.session.route = this.model.getRouteByName(route_name);
            var aq: AvailabilityQuery2 = new AvailabilityQuery2(this.model, this.translate);
            aq.class = params.class;
            
            aq.passengers = []; params.passengers;
                       
            for (var i = 0; i < params.passengers.length; i++) {
              let aa: string = "" + params.passengers[i];
              let bb = parseInt(aa);
              if (aq.passengers.length < bb) {
                aq.passengers[bb] = 0;
              }
              aq.passengers[bb]++;
            }
            aq.round = (params.round == "true");
            
            var endn = Number.parseInt(params.end);
            
            if (params.stops) {
              var aaa = params.stops;
              if (typeof (aaa) == 'string') {
                aaa = [aaa];
              }
              for (var i = 0; i < aaa.length; i++) {
                var bbb = aaa[i];
                let ccc = parseInt(bbb);
                let ts: TrainStop = this.model.getTrainStopById(ccc);
                
              }
            }
            this.session.query = aq;
            
            observer.next(true);
          })


        } else {
          observer.next(false);
          
        }
      });

    });
  }
  /** .*/
  goBack(): void {
    this.location.back();
  }
  /** .*/
  makeSegments(schedule: Schedule, query: AvailabilityQuery): Segment[] {
    var segments: Segment[] = [];
    var segments_by_ts = {};

    var routets: TrainStop[] = [];
    var direction = Direction.up;
    var fromkm = 0; var tokm = 0;

    if (fromkm > tokm) {
      routets.reverse();
    }
    for (let i = 0; i < query.trips.length; i++) {
      const e = query.trips[i];
      let ts0: any = e.id_src;// this.model.getTrainStopById(e.id_src);    
      let ts1: any = e.id_dst;// this.model.getTrainStopById(e.id_dst);   

      var segment: Segment = new Segment(i + 1, ts0, ts1, [], query);

      segments.push(segment);
    }
    for (var i = 0; i < (routets.length - 1); i++) {
      let ts0: TrainStop = routets[i];
      let ts1: TrainStop = routets[i + 1];
      var segment: Segment = new Segment(i + 1, ts0, ts1, [], query);
      
      if (direction == 1) {
        segments_by_ts[ts0.id] = segment;
      }
      else if (fromkm < tokm) {
        segments_by_ts[ts1.id] = segment;
      }
      if (i > 0) {
        let prev: Segment = segments[i - 1];
        segment.previous = prev;
      }
      segments.push(segment);
    }
    for (var i = 0; i < schedule.travels.length; i++) {
      let t: Travel = schedule.travels[i];
      let segment = segments[i];

      if (segment == null) { continue; }
      segment.travels.push(t);
    }
    var k = 1;
    var segments2: Segment[] = [];
    for (var j = 0; j < segments.length; j++) {
      let s: Segment = segments[j];
      if (s.travels.length > 0) {
        s.n = k++;
        s.previous = segments2.length > 0 ? segments2[segments2.length - 1] : null;
        segments2.push(s);
      }
    }

    this.btnNext = null;
    return segments2
  }
}
